import Dashboard from "../../slices/dashboard/Dashboard";

const dashboardReducer = {
    dashboard: Dashboard,
};

export default dashboardReducer;